
import { useEffect, useState } from "react";
import { HiveAPI } from "../api/hivemind";

export default function useScenario() {
  const [map, setMap] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    HiveAPI.currentMap().then((m) => {
      if (!mounted) return;
      setMap(m);
      setLoading(false);
    }).catch((e) => {
      console.error("Failed to load map:", e);
      setLoading(false);
    });
    return () => { mounted = false; };
  }, []);

  return { map, loading };
}
